import React from 'react';
import Missions from '@screens/players/player.details.tabs/daily.missions/player.missions';
import LatestMissions from '@screens/players/player.details.tabs/daily.missions/player.latest.missions';
import { PlayerDataProps } from '@screens/players/types/player.data.props';

const DailyMissions = ({ player }: PlayerDataProps) => {
  return (
    <>
      <Missions player={player} />
      <LatestMissions />
    </>
  );
};

export default DailyMissions;
